import { I18NextContext } from "./services/i18nService";

const timePickerTemplate = `
  	<div 
		class="timepicker-popover-content"
	  	uib-timepicker
    	ng-model="$ctrl.timepickerDate"
    	hour-step="1"
		minute-step="15"
		arrowkeys="true"
		show-meridian="$ctrl.isTwelveHour"
		click-outside="$ctrl.handleClickOutside()"
	>
	</div>
`;

// Override the bootstrap decorator's checkbox template to include the
// app theme's custom <i class="input-helper"> visual indicator.
const schemaFormCheckboxTemplate = `<div class="checkbox schema-form-checkbox {{form.htmlClass}}"
     ng-class="{'has-error': form.disableErrorState !== true && hasError(), 'has-success': form.disableSuccessState !== true && hasSuccess()}">
  <label class="{{form.labelHtmlClass}}">
    <input type="checkbox"
           sf-changed="form"
           ng-disabled="form.readonly"
           sf-field-model
           schema-validate="form"
           class="{{form.fieldHtmlClass}}"
           name="{{form.key.slice(-1)[0]}}">
    <i class="input-helper"></i>
    <span ng-bind-html="form.title"></span>
  </label>
  <div class="help-block" sf-message="form.description"></div>
</div>`;

export default function bootstrapper(
	$rootScope,
	$templateCache,
	uiState,
	config,
	$logger
) {
	$rootScope.uiState = uiState;

	$templateCache.put("time-picker-template.html", timePickerTemplate);
	$templateCache.put("decorators/bootstrap/checkbox.html", schemaFormCheckboxTemplate);

	I18NextContext.Instance.init($logger);
}
